<template>
  <v-container>
    <v-dialog
      persistent
      v-model="show"
      :width="dialogWidth"
      lazy
      transition="dialog-bottom-transition"
    >
      <v-card
        color="primary"
        :style="{ height: '80vh', textAlign: 'center' }"
        v-if="show"
      >
        <h2>Please scan all serials for the following products</h2>
        <div
          :style="{ height: '90%', overflow: 'scroll' }"
          v-if="resultsModel.length"
        >
          <v-stepper
            v-for="(item, rIndex) in resultsModel"
            v-model="currentStep"
            vertical
            class="elevation-0"
            :key="rIndex"
          >
            <v-stepper-step :step="rIndex + 1" :key="`${rIndex + 1}-head`">{{
              item.product[1]
            }}</v-stepper-step>
            <v-stepper-content
              :key="`${rIndex + 1}-content`"
              :step="rIndex + 1"
            >
              <v-card color="primary elevation-0">
                <v-combobox
                  deletable-chips
                  v-model="item.enteredSerials"
                  label="Scan All Serials"
                  :hint="
                    item.enteredValue != item.enteredSerials.length
                      ? `You counted ${item.enteredValue} serials but have scanned ${item.enteredSerials.length}!`
                      : ''
                  "
                  multiple
                  persistent-hint
                  chips
                  :color="
                    item.enteredValue != item.enteredSerials.length
                      ? 'error'
                      : 'success'
                  "
                />
                <v-card-actions>
                  <v-btn
                    @click="
                      currentStep > 1 ? currentStep-- : $emit('input', false)
                    "
                    >{{currentStep &gt; 1 ? 'Back' : 'Cancel'}}</v-btn
                  >
                  <v-btn
                    color="success"
                    @click="
                      currentStep < resultsModel.length
                        ? currentStep++
                        : submitResults()
                    "
                    :disabled="item.enteredValue != item.enteredSerials.length"
                    >{{currentStep &lt; resultsModel.length ? 'Next' : 'Submit'}}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    value: Boolean,
    results: Array,
    currentLocation: Array
  },
  data() {
    return {
      currentStep: 1,
      resultsModel: []
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.resultsModel = this.results.filter(item => {
          if (item.tracking == "serial" && item.state == "waiting") {
            return item;
          }
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      storedType: "inventory/getSearchType",
      settings: "settings/getSettings",
      filters: "inventory/getFilters"
    }),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },

    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.md) {
        return "80%";
      }
      return "70%";
    }
  },
  methods: {
    ...mapActions({
      createException: "inventory/createException",
      updateEvalDate: "inventory/updateEvalDate",
      loadLocations: "inventory/searchLocations",
      getSettings: "settings/getSettings"
    }),
    async submitResults() {
      this.getSettings("inventory");
      let finalResults = this.resultsModel;

      finalResults.push(
        this.results.filter(item => {
          if (item.state == "correct") return item;
          else if (item.tracking != "serial" && item.state != "waiting")
            return item;
          else if (item.tracking == "lot" && item.state == "waiting")
            return item;
        })
      );
      finalResults.forEach(item => {
        if (item.tracking == "serial" && item.state == "waiting") {
          item.invalidSerials = this.compareArray(
            item.enteredSerials,
            item.correctSerials
          );
        }
      });
      finalResults.forEach(async result => {
        await this.createException(result);
      });
      this.$emit("input", false);
      await this.updateEvalDate(this.currentLocation[0]);
      await this.loadLocations({
        type: this.storedType,
        limit: this.getLimit()
      });
      this.$router.push(`/inventory`);

      this.$store.dispatch("app/setSnackbar", {
        text: "Evaluation Complete",
        color: "green"
      });
    },

    compareArray(a1, a2) {
      return a1
        .filter(x => !a2.includes(x))
        .concat(a2.filter(x => !a1.includes(x)));
    },

    getLimit() {
      let limit = this.settings.filter(setting => {
        return (
          setting._id ===
          this.filters.filter(filter => {
            return filter.value === this.storedType;
          })[0].settingID
        );
      })[0].value;

      return limit;
    }
  }
};
</script>

<style></style>
